<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Remove Area</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <p>
      Are you sure you want to remove {{ locationArea.name }}? This action cannot be undone.
    </p>
    <p>
      Any Events using this area will no longer be subject to its capacity limits.
    </p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-danger"
            (click)="handleRemove()"
            *ngIf="!loadingRemove">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingRemove">
      Loading...
    </button>
  </div>

</ng-container>
